import { object } from 'yup'
import { endTimeSchema, nameSchema, startTimeSchema } from './userSchema'

export const shiftSchema = object({
  end_time: endTimeSchema,
  name: nameSchema,
  start_time: startTimeSchema
})
